module.exports = __webpack_public_path__ + "img/oa_banner2.7c2600b4.png";